<button mat-mini-fab class="mat-mini-fab-map-control" [matTooltip]="'map.control_print_map.tooltip' | translate" matTooltipPosition="left"
  matTooltipShowDelay="500" (click)="openMap()">
  <mat-icon>print</mat-icon>
</button>
